import React from 'react';
interface State {
  message: string;
}

/**
 * A blank page is never an acceptable outcome.
 *
 * If any screen throws while rendering, React unmounts the whole tree and the
 * browser is left showing nothing at all. This catches that, says so plainly
 * in Portal's own language, and logs the real error for diagnosis.
 */
export class ErrorBoundary extends React.Component<{
  children: React.ReactNode;
}, State> {
  state: State = {
    message: ''
  };
  static getDerivedStateFromError(error: unknown): State {
    return {
      message: error instanceof Error ? error.message : 'Unknown error'
    };
  }
  componentDidCatch(error: unknown, info: unknown) {
    console.error('[portal] render failed', error, info);
  }
  render() {
    if (!this.state.message) return this.props.children;
    return <div className="min-h-screen w-full bg-paper text-ink" data-id="element-395" data-mp="1e9htjfivjbmv">
        <div className="mx-auto max-w-portal px-6 pt-24 sm:px-10" data-id="element-396" data-mp="1eb15wv1et2jd">
          <p className="label m-0 text-mute" data-id="element-397" data-mp="19hg9h7fgsgma">Something went wrong</p>
          <p className="mt-5 max-w-lg text-lg leading-relaxed" data-id="element-398" data-mp="3n4ri7c6ed2dx">
            This page could not be displayed. Reload to try again — if it keeps happening, let
            Portal know.
          </p>
          <button type="button" onClick={() => window.location.reload()} className="label mt-9 border border-ink px-7 py-4 text-ink transition-colors duration-150 ease-out hover:bg-ink hover:text-paper" data-id="element-399" data-mp="3dfztdcwmuy78">
            Reload
          </button>
        </div>
      </div>;
  }
}